import * as Types from './types';
import { Dispatch } from 'redux';
import {
  IAction,
  IActionMethods,
  KEEP_THE_SAME,
  StateStatus,
} from '../../../redux/utils/common';
import * as VatReturnRemindersService from '../../../services/api/vatReturn_reminders';

class FetchVatReturnRemindersList implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_VATRETURN_REMINDERS_LIST,
      status: StateStatus.Pending,
      data: KEEP_THE_SAME,
    };
  }

  onSuccess(data: any): IAction {
    return {
      type: Types.SET_VATRETURN_REMINDERS_LIST,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_VATRETURN_REMINDERS_LIST,
      status: StateStatus.Failed,
      data: KEEP_THE_SAME,
    };
  }

  action(payload: VatReturnRemindersService.IVatReturnRemindersListInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response =
          await VatReturnRemindersService.fetchVatReturnRemindersList(payload);
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('Fetch VatReturnReminders Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

interface IVatReturnRemindersToGenerate
  extends VatReturnRemindersService.IVatReturnRemindersToGenerateInput {
  onFinish?: (success: boolean) => void;
}
class VatReturnRemindersToGenerate implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_VATRETURN_REMINDERS_TO_GENERATE,
      status: StateStatus.Pending,
      data: {},
    };
  }

  onSuccess(): IAction {
    return {
      type: Types.SET_VATRETURN_REMINDERS_TO_GENERATE,
      status: StateStatus.Success,
      data: {},
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_VATRETURN_REMINDERS_TO_GENERATE,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: IVatReturnRemindersToGenerate): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        const { onFinish, ...rest } = payload;
        await VatReturnRemindersService.vatReturnRemindersToGenerate(rest);
        dispatch(this.onSuccess());
        onFinish && onFinish(true);
      } catch (error: any) {
        const { onFinish } = payload;
        // console.log('VatReturnRemindersToGenerate Error:', error.message);
        dispatch(this.onFailed());
        onFinish && onFinish(false);
      }
    };
  }
}

export default {
  fetchVatReturnRemindersListListAction: (
    payload: VatReturnRemindersService.IVatReturnRemindersListInput
  ) => new FetchVatReturnRemindersList().action(payload),
  vatReturnRemindersToGenerateAction: (
    payload: IVatReturnRemindersToGenerate
  ) => new VatReturnRemindersToGenerate().action(payload),
};
